import React from 'react';
import { TIMEZONE_GROUPS, ALL_TIMEZONE_VALUES, DEFAULT_TIMEZONE } from '../lib/timezones';

/**
 * Grouped <select> for IANA timezones — used everywhere we previously had a
 * free-text timezone input. If the current ``value`` isn't in our curated list
 * (e.g. a legacy account), it's surfaced under a "Current" optgroup so the user
 * can keep it without seeing an empty field.
 */
export function TimezoneSelect({ value, onChange, className = '', dataTestid, id }) {
  const v = value || DEFAULT_TIMEZONE;
  const isKnown = ALL_TIMEZONE_VALUES.includes(v);
  return (
    <select
      id={id}
      data-testid={dataTestid || 'timezone-select'}
      value={v}
      onChange={(e) => onChange(e.target.value)}
      className={
        className ||
        'w-full px-3 py-2.5 rounded-md border border-neutral-200 text-[13.5px] bg-white focus:border-[#f5b300] focus:ring-2 focus:ring-[#f5b300]/20 outline-none'
      }
    >
      {!isKnown && (
        <optgroup label="Current">
          <option value={v}>{v}</option>
        </optgroup>
      )}
      {TIMEZONE_GROUPS.map((g) => (
        <optgroup key={g.label} label={g.label}>
          {g.zones.map((z) => (
            <option key={z.value} value={z.value}>{z.label}</option>
          ))}
        </optgroup>
      ))}
    </select>
  );
}
